(() => {

    let uncollapse = (e) => {
        e.preventDefault();
        let self = e.target;
        let targetId = self.dataset.uncollapse;

        document.getElementById(targetId).classList.add('active');
        self.style.display = 'none';
    };

    let targets = document.querySelectorAll('[data-uncollapse]');

    for (let i=0; i<targets.length; i++) {
        targets[i].addEventListener('click', uncollapse);
    }

})();